import { api } from 'app/app.api';
import { notificationActions } from 'components/notifications/actions/notification';

import {
  ReadNotificationApiArg,
  ReadNotificationApiResponse,
  ReadNotificationsApiArg,
  ReadNotificationsApiResponse,
  UpdateNotificationsAsReadApiArg,
  UpdateNotificationsAsReadApiResponse,
} from './types/notificationsApi.types';
import { transformReadNotifications } from './utils/transformResponse';

export const notificationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    readNotifications: builder.query<
      ReadNotificationsApiResponse,
      ReadNotificationsApiArg
    >({
      query: ({ unreadOnly: unread }) => ({
        version: 1,
        path: 'notifications',
        params: { unread },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const result = await queryFulfilled;
          dispatch(
            notificationActions.notificationGetPersistedSucceeded(result.data),
          );
        } catch (e) {
          // Do nothing
        }
      },
      transformResponse: transformReadNotifications,
    }),
    readNotification: builder.query<
      ReadNotificationApiResponse,
      ReadNotificationApiArg
    >({
      query: ({ notificationId }) => ({
        version: 1,
        path: `notifications/${notificationId}`,
      }),
    }),
    updateNotificationsAsRead: builder.query<
      UpdateNotificationsAsReadApiResponse,
      UpdateNotificationsAsReadApiArg
    >({
      query: ({ notificationIds: notification_ids }) => ({
        version: 1,
        method: 'PUT',
        path: 'notifications/read',
        body: {
          notification_ids,
        },
      }),
    }),
  }),
});
